@if (get(featureSolutionsRow, 'feature_solutions', '')) {
  <section
    [class.gray-bg]="get(featureSolutionsRow, 'feature_solutions.gray_background', '')"
    >
    <div class="d-flex flex-wrap flex-row container-gridless feature-solutions">
      @if (get(featureSolutionsRow, 'feature_solutions.feature_solutions_title', '')) {
        <div
          class="category-top-title d-flex flex-row justify-content-center"
          >
          <h2 class="col-md-9 text-center m-0">
            {{ get(featureSolutionsRow, 'feature_solutions.feature_solutions_title', '') }}
          </h2>
        </div>
      }
      <div class="d-flex flex-row flex-wrap justify-content-center w-100 solution-row" [class.has-tags]="rowHasTags">
        @for (solution of solutions; track solution; let i = $index) {
          <div
            class="col-md-4 solution"
            >
            <div class="d-flex flex-column card-1">
              <div
                id="cms-partial-category-feature-solutions-img"
                class="text-center"
                [class.hover-effect]="get(solution, 'solution_page_link.routerLink', '')"
                        [ngStyle]="{
                            'background-image': 'url(' + getBackgroundImage(i) + ')',
                            'background-repeat': 'no-repeat',
                            'background-size': 'contain'
                        }"
                >
                <a tabindex="-1" [routerLink]="get(solution, 'solution_page_link.routerLink', '') || null">
                  @if (get(solution, 'solution_image.href', '')) {
                    <img
                      [src]="getWebpImg(get(solution, 'solution_image.href', ''))"
                      alt="Solution image"
                      />
                  }
                </a>
              </div>
              <!--
                Always rendered, even with no tags, so the card's DOM is identical on the server
                and in the browser. ngSkipHydration lets the client re-filter with a fresh clock
                without a hydration mismatch when a tag expired while the SSR page sat in cache.
                Sits outside the card link: the chips are display only and should not become
                part of the link's accessible name.
              -->
              <div class="tag-row">
                <featured-solution-tags ngSkipHydration [tags]="activeTags[i] || []"></featured-solution-tags>
              </div>
              <a
                class="top-card text-center"
                [class.hover-effect]="get(solution, 'solution_page_link.routerLink', '')"
                [routerLink]="get(solution, 'solution_page_link.routerLink', '') || null"
                >
                <h4 class="solution-title text-center m-0" [class.title]="get(solution, 'solution_page_link.routerLink', '')">
                  @if (solution.solution_title; as splitTitle) {
                    <span>{{ splitWord(splitTitle).firstPart }}</span>
                    <span class="last-word">
                      <span [class.last-word-text]="get(solution, 'solution_page_link.routerLink', '')">{{
                        splitWord(splitTitle).lastPart
                      }}</span>
                      @if (get(solution, 'solution_page_link.routerLink', '')) {
                        <i-feather name="chevron-right"></i-feather>
                      }
                    </span>
                  }
                </h4>
                @if (get(solution, 'displayMpn', '')) {
                  <div class="part-number text-center px-1 pt-base pb-1">
                    {{ get(solution, 'displayMpn', '') }}
                  </div>
                }
                <hr class="divider mb-0 mt-1" />
                <div class="d-flex flex-column align-items-center mt-3">
                  @if (get(solution, 'price', '') && (solution.isActive || !get(solution, 'configuratorMpn', ''))) {
                    <div>
                      <div class="text-center font-color start-text">Starting at</div>
                      <h4 class="mt-base pb-2 text-center price">{{ get(solution, 'price', '') | currency }}</h4>
                    </div>
                  }
                  @if (get(solution, 'button_text_select')) {
                    <!-- Not an <a>: this sits inside the card link, and nested anchors break SSR hydration -->
                    <span
                      class="spec-link"
                      role="link"
                      [routerLink]="get(solution, 'spec_link.routerLink', '')"
                      [queryParams]="get(solution, 'spec_link.queryParams', {})"
                      (click)="$event.preventDefault(); $event.stopPropagation()"
                      (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); $any($event.currentTarget).click()"
                      >
                      {{ get(solution, 'button_text_select', '') }}
                    </span>
                  }
                </div>
              </a>
              <div class="lower-half-card d-flex flex-column fx-col justify-content-between">
                <div>
                  @for (props of get(solution, 'system_value_props', ''); track props) {
                    <div class="d-flex flex-row lower-half-card-container">
                      <span class="solution-icon" [style.--icon-url]="getIconUrl(get(props, 'icon.href', ''))"></span>
                      <span class="value-line">{{ props.value_prop_line }}</span>
                    </div>
                  }
                  @if (!isEmpty(get(solution, 'specs', ''))) {
                    <h5 class="mb-1" [class.pt-2]="get(solution, 'system_value_props', []).length">
                      Highlights
                    </h5>
                  }
                  @for (spec of get(solution, 'specs', []); track spec) {
                    <div class="d-flex flex-row specs lower-half-card-container">
                      <span class="spec-labels">{{ get(spec, 'spec_label', '') }}</span>
                      <span class="value-line">{{ get(spec, 'spec_line', '') }}</span>
                    </div>
                  }
                </div>
                <div (click)="onButtonClick($event)">
                  @if (solution?.isActive && !configuratorService?.isBlacklisted(get(solution, 'configuratorMpn', ''))) {
                    <a
                      [href]="encodeConfiguratorUrl('https://configurator.exxactcorp.com/configure/', get(solution, 'configuratorMpn', ''))"
                      >
                      <button-component
                                      [buttonOptions]="{
                                          text: 'Configure',
                                          type: 'primary',
                                          iconPosition: 'right',
                                          iconName: 'tool',
                                          class: 'w-100 mt-2',
                                          innerTabIndex: -1
                                      }"
                      ></button-component>
                    </a>
                  }
                  @if (get(solution, 'marketo_form_selection.form_selection', '') !== 'no_form') {
                    @if (get(solution, 'marketo_form_selection.form_selection', '') == 'default_form') {
                      <button-component
                        data-cy="marketo-form"
                                    (click)="
                                        solutionID && bootstrapMarketoService.openBootstrapMarketoDialog(solutionID, 'edit', {
                                            title: dataTitle,
                                            url: dataUrl,
                                            productInfo: {
                                                mpn: get(solution, 'displayMpn', ''),
                                                solutionTitle: get(solution, 'solution_title', '')
                                            }
                                        })
                                    "
                                    [buttonOptions]="{
                                        text:
                                            solution?.button_text == undefined || solution?.button_text == '' ? 'Get a Quote' : solution?.button_text,
                                        type: 'secondary',
                                        iconPosition: 'right',
                                        iconName: 'chevron-right',
                                        class: 'w-100 mt-1',
                                        disabled: !solutionID
                                    }"
                    ></button-component>
                  }
                  @if (get(solution, 'marketo_form_selection.form_selection', '') == 'other_form') {
                    <button-component
                      data-cy="marketo-form"
                                    (click)="
                                        get(solution, 'marketo_form_selection.marketo_forms.id', '') && bootstrapMarketoService.openBootstrapMarketoDialog(
                                            get(solution, 'marketo_form_selection.marketo_forms.id', ''),
                                            'edit',
                                            {
                                                title: dataTitle,
                                                url: dataUrl
                                            }
                                        )
                                    "
                                    [buttonOptions]="{
                                        text:
                                            solution?.button_text == undefined || solution?.button_text == '' ? 'Get a Quote' : solution?.button_text,
                                        type: 'secondary',
                                        iconPosition: 'right',
                                        iconName: 'chevron-right',
                                        class: 'w-100 mt-1',
                                        disabled: !get(solution, 'marketo_form_selection.marketo_forms.id', '')
                                    }"
                  ></button-component>
                }
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
</section>
}
@if (get(featureSolutionsRow, 'feature_solutions.split_line', '')) {
  <hr class="m-0 mb-3" />
}
